<template>
  <ElForm
    class="mail-service-search-form"
    @submit.native.prevent="searchEmails"
  >
    <ElFormItem class="mail-service-search-form__input-form-item">
      <ElInput
        v-model.trim="emailToSearch"
        class="mail-service-search-form__input"
        :placeholder="$t('ADVERTISEMENT.MAIL_SERVICE.SEARCH_INPUT_PLACEHOLDER')"
      />
    </ElFormItem>
    <ElFormItem>
      <ElButton
        class="mail-service-search-form__submit-btn"
        :disabled="!hasAnyEmailEntered"
        type="text"
        :icon="arrowIcon"
        native-type="submit"
        @click="searchEmails"
      />
    </ElFormItem>
  </ElForm>
</template>

<script>
import { mapGetters } from 'vuex';
import { DIRECTION } from '@/store/types';

export default {
  name: 'MailServiceSearch',
  data() {
    return {
      emailToSearch: '',
    };
  },
  computed: {
    ...mapGetters({
      direction: DIRECTION,
    }),
    arrowIcon() {
      return this.direction === 'rtl' ? 'el-icon-back' : 'el-icon-right';
    },
    hasAnyEmailEntered() {
      return Boolean(this.emailToSearch);
    },
  },
  watch: {
    emailToSearch() {
      if (!this.emailToSearch) this.searchEmails();
    },
  },
  methods: {
    searchEmails() {
      this.$emit('searchEmails', this.emailToSearch);
    },
  },
};
</script>

<style lang="scss">
.mail-service-search-form {
  padding: $global-padding * 1.5 $global-padding * 1.5 0;
  display: flex;
  align-items: center;

  &__input-form-item {
    max-width: rem-calc(400px);
    width: 100%;

    margin-right: $global-margin;
    @include rtl() {
      margin-right: 0;
      margin-left: $global-margin;
    }
  }

  &__input {
    width: 100%;
  }

  &__submit-btn {
    font-size: rem-calc(18px);
  }
}
</style>
